module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAAmCAYAAACBOhYpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEsSURBVHgB7do9agJRFIbhc64uwBUkKSa9EwhYpkw6t5AdJCvJEtxCbMTSUgTR3inUFVj7M8d7hbGQkXE+UHD8HrgMylQvB+4pRsVrtT5fNjvtmGlT1BpyBeNRT+7cvz+/qjqvh2DrrZscYqkJndX258PMYrdJ3d+1pquCQqeO8+XaQmU0nVBZDUYD1PP+fI2eJYqeJEmWMksWx99FsverLnfSskCnzyKXvnfvcqNl03L6LPIIUxbo2/vXTZazCiy3R7wIAIwGYDQAVw4AVw4AVw4AVw4ALwIAowEYDcCVA8CVA8CVA8CVA8CLAMBoAEYDMBqA0QCMBmA0AKMBGA3AaAAfTVdCpTgVmwqV0XW7mn1z2i4WOv246bA/T2tprHr4EJfyhVgDf+LwofIedLiBaT0ZHFwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/style1.png
// module id = X/o1
// module chunks = 25